module.exports = __webpack_public_path__ + "media/images/gallery/constellations/equuleus/equ_names-b15e1a5d5a3ae4897f41dd170d90d956.gif";